import { Component, OnInit, OnDestroy, AfterViewInit, EventEmitter, Input, Output } from '@angular/core';

declare var tinymce: any;
declare var jQuery: any;

@Component({
  selector: 'app-tinymce',
  templateUrl: './tinymce.component.html',
  styleUrls: ['./tinymce.component.css'],
})
export class TinymceComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() elementId: string;
  @Input() initialContent: string;
  @Output() onEditorKeyup = new EventEmitter<any>();

  editor: any;

  constructor() {}

  ngOnInit() {
    if (!this.elementId) this.elementId = `tinymce-${this.randomString(10)}`;
  }

  ngAfterViewInit() {
    if (typeof tinymce === 'undefined' || typeof tinymce.init !== 'function') return;
    let toolbar1: string;
    let toolbar2: string;
    let plugins: Array<Array<string>>;
    toolbar1 = 'bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link';
    toolbar2 = 'forecolor backcolor | formatselect fontsizeselect';
    plugins = [['advlist anchor autolink autoresize autosave charmap code directionality emoticons fullscreen'], ['hr image importcss insertdatetime link lists media nonbreaking pagebreak paste preview'], ['print save searchreplace table template visualblocks visualchars wordcount']];
    tinymce.init({
      selector: '#' + this.elementId,
      branding: false,
      browser_spellcheck: true,
      contextmenu: false,
      image_advtab: true,
      importcss_append: true,
      paste_data_images: true,
      relative_urls: true,
      theme: 'silver',
      force_p_newlines: false,
      forced_root_block: false,
      setup: (editor: any) => {
        this.editor = editor;
        editor.on('init', () => this.enableNativeSpellcheck(editor));
        editor.on('keyup', () => {
          const content = editor.getContent();
          this.onEditorKeyup.emit(content);
        });
      },
      menubar: false,
      min_height: 300,
      toolbar1: toolbar1,
      toolbar2: toolbar2,
      plugins: [['advlist anchor autolink autosave charmap code directionality emoticons fullscreen'], ['hr image importcss insertdatetime link lists media nonbreaking pagebreak paste preview'], ['print save searchreplace table template visualblocks visualchars wordcount']],
    });
  }

  enableNativeSpellcheck(editor: any) {
    const body = editor && typeof editor.getBody === 'function' ? editor.getBody() : null;
    if (!body) return;

    body.setAttribute('spellcheck', 'true');
    body.spellcheck = true;
  }

  ngOnDestroy() {
    if (typeof tinymce !== 'undefined' && this.editor) tinymce.remove(this.editor);
  }

  setContent(text: string) {
    this.editor.setContent(text);
  }

  randomString(len: number) {
    var text = '';
    var charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
    var len = charset.length;
    for (var i = 0; i < len; i++) text += charset.charAt(Math.floor(Math.random() * len));
    return text;
  }

  triggerContentOutput() {
    if (!this.editor) return;
    const content = this.editor.getContent();
    if (!content) return;
    this.onEditorKeyup.emit(content);
  }
}
